import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import axios from "../lib/AxiosGo";
import { toast } from "react-toastify";

const ReporterPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/reporters/data");
      setData(response.data);
    } catch (error) {
      console.error("Error fetching reporter data:", error);
      toast.error("Gagal mengambil data pelapor");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (reportId) => {
    if (!window.confirm("Apakah Anda yakin ingin menghapus data pelapor ini?")) return;
    try {
      await axios.delete(`/reporters/${reportId}`);
      toast.success("Data pelapor berhasil dihapus!");
      getData();
    } catch (error) {
      console.error("Error deleting reporter:", error);
      toast.error("Gagal menghapus data pelapor");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Data Pelapor (Masyarakat)" />

        <div className="card h-100 radius-12 border-0 shadow-sm">
          <div className="card-header py-16 px-24 bg-base d-flex align-items-center justify-content-between border border-end-0 border-start-0 border-top-0">
            <div>
              <h5 className="card-title text-lg text-primary-light mb-0">
                Identitas Pelapor Terdaftar
              </h5>
              <p className="text-xs text-muted mb-0">Daftar kontak masyarakat yang mengirimkan pengaduan melalui WhatsApp Bot</p>
            </div>
            <button
              onClick={getData}
              className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1 radius-8 px-12"
            >
              <Icon icon="mdi:refresh" /> Refresh Data
            </button>
          </div>
          <div className="card-body p-16">
            <div className="table-responsive">
              <table className="table vertical-striped-table mb-0 align-middle">
                <thead>
                  <tr>
                    <th>Nama Lengkap</th>
                    <th>Nomor WhatsApp / HP</th>
                    <th>Penerima (Nomor Bot / Device)</th>
                    <th>Jenis Kelamin</th>
                    <th>Alamat Domisili</th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-32 text-muted">
                        <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                        Memuat data pelapor...
                      </td>
                    </tr>
                  ) : data.length > 0 ? (
                    data.map((reporter) => (
                      <tr key={reporter.id}>
                        <td className="fw-semibold text-primary-light">
                          <Icon icon="solar:user-bold" className="me-2 text-primary" />
                          {reporter.full_name || "Masyarakat"}
                        </td>
                        <td>
                          <span className="badge bg-success-50 text-success-700 px-8 py-4 radius-6">
                            <Icon icon="logos:whatsapp-icon" className="me-1" />
                            {reporter.phone || reporter.no_wa || "-"}
                          </span>
                        </td>
                        <td>
                          {reporter.bot_number || reporter.device_name || reporter.device_id ? (
                            <div className="d-flex flex-column">
                              <span className="badge bg-primary-50 text-primary-700 px-8 py-4 radius-6 w-fit d-inline-flex align-items-center gap-1">
                                <Icon icon="mdi:robot" /> {reporter.device_name || "Bot Device"}
                              </span>
                              <span className="text-xs text-muted mt-2">
                                {reporter.bot_number ? `No: ${reporter.bot_number}` : (reporter.device_id ? `ID: ${reporter.device_id}` : "")}
                              </span>
                            </div>
                          ) : (
                            <span className="text-muted text-xs">-</span>
                          )}
                        </td>
                        <td>{reporter.gender || "-"}</td>
                        <td>{reporter.address || "-"}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-xs btn-outline-danger d-inline-flex align-items-center gap-1 radius-6"
                            onClick={() => handleDelete(reporter.id)}
                            title="Hapus Data Pelapor"
                          >
                            <Icon icon="iconamoon:trash-fill" /> Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-24 text-muted">
                        Belum ada data pelapor yang tersimpan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ReporterPage;
